

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */
import purl from '@allmarkedup/purl/purl';
import $ from 'jquery';

import { getTranslator } from '../js/i18n';
import tools from '../js/tools';
import { useGuiHelper } from './wizard-gui-helper';

const t = getTranslator();

function MobileQrSignatureHandler(wizardListener, _api) {
    //link to main page to show dialog
    this._guiHelper = useGuiHelper(wizardListener);
    if(!_api) {
        //default api for uniwizard, doclist passes its own implementation
        _api = {
            dynamicAction(params, options, cb) {
                return tools.api('', params, options, cb);
            },
            execApi(command, params, options, cb) {
                return tools.api(command, params, options, cb);
            },
            documentId: purl().param('document'),
        };
    }
    this._api = _api;
}
MobileQrSignatureHandler.prototype = {
    init(cb) {
        cb();
    },
    updateApi(_api) {
        const _old = this._api;
        this._api = _api;
        return _old;
    },
    _dynamicAction(signAction, params, pleaseWait) {
        //stringify, because handler parses this data automatically
        const data = {
            'dynamic-action': 'sign-qualified-handler-action',
            'signAction': signAction,
            'signActionParams': JSON.stringify(params),
        };
        return this._api.dynamicAction(data, { errors: true, noalert: true, waiting: pleaseWait });
    },
    executeSignature(data, options, cb) {
        const self = this;
        $.when().then(function() {
            //we convert page action to custom sign action
            //because basically we have nothing to do now, just save signature parameters and show qr code
            //all document modifications will be done later, from phone

            //data is query string
            data = $.param(data);
            const signActionData = { signActionData: data };
            return self._dynamicAction('generateQrCode', signActionData);
        })
            .then(function(signatureData1) {
                const signActionResult = signatureData1.signActionResult;
                const qrCodeJson = signActionResult.qrCodeJson;
                if(qrCodeJson) {
                    delete signActionResult.qrCodeJson;
                    window.console && console.log && console.log(JSON.stringify(qrCodeJson));
                }
                cb(null, signatureData1);
            })
            .fail(function(err) {
                cb(err);
            });
    },
    finishedExternally: true,
    _dialog: null,
    finalizeSignature(signatureData1, options, cb) {
        const self = this;
        self._dialog = null;
        const docId = self._api.documentId;
        $.when().then(function() {
            const deferred = $.Deferred();
            let finished = false;
            let working = false;
            let interval = null;
            function checkFinished(force) {
                if(finished || (working && !force)) {
                    return;
                }
                working = true;
                const data = {
                    document: docId,
                };
                self._api.execApi('mobileqrstatus.cmd', data, { noalert: true, errors: true, waiting: !!force })
                    .then(function(status) {
                        if(status.finished) {
                            abortChecking();
                            self._dialog.modal('hide');
                            self._dialog = null;
                            let qrSignResult = status.qrSignResult;
                            //it is object of document ids, in case of doclist we return entire object
                            //in case of single document we return one document
                            if(qrSignResult[docId])
                                qrSignResult = qrSignResult[docId];
                            deferred.resolve(qrSignResult);
                        }
                    })
                    .catch(function(err) {
                    //show error, but continue
                        tools.scripterr(err);
                    })
                    .always(function() {
                        working = false;
                    });
            }
            function abortChecking() {
                finished = true;
                clearInterval(interval);
            }

            const url = 'viewerui/mobileqrgetcode.cmd?' + $.param({ document: docId, format: 'png', t: new Date().getTime() });
            const params = {
                title: t('mobile_qr.title'),
                url,
            };
            self._dialog = self._guiHelper.showDialog2('mustache-mobile-qr-dialog', params);
            function checkCloseDialog() {
                self._guiHelper.confirm2()
                    .then(() => {
                        abortChecking();
                        const err = new Error('cancelled');
                        err.no_show_error = true;
                        err.user_cancelled = true;
                        //cancelSignature will be called automatically in case of error
                        return deferred.reject(err);
                    })
                    .catch((err) => {
                        abortChecking();
                        return deferred.reject(err);
                    });
            }
            self._dialog.on('hide.bs.modal', function(evt) {
                if(!finished) {
                    evt.preventDefault();
                    evt.stopImmediatePropagation();
                    checkCloseDialog();
                }
            });
            self._dialog.find('.btn-annula').on('click', checkCloseDialog);
            self._dialog.find('.btn-refresh').on('click', function() {
                checkFinished(true);
            });
            interval = setInterval(checkFinished, 5000);
            return deferred.promise();
        })
            .then(function(signatureData2) {
                cb(null, signatureData2);
            })
            .fail(function(err) {
                cb(err);
            });
    },
    cancelSignature(options, cb) {
        const self = this;
        $.when().then(function() {
            if(self._dialog) {
                self._dialog.modal('hide');
                self._dialog = null;
            }
        })
            .then(function() {
                return self._dynamicAction('cancelSignature', {}, true);
            })
            .catch(function(err) {
            //show error, but continue
                tools.scripterr(err);
            })
            .always(function() {
                cb();
            });
    },
};

export default {
    'mobile_qr': MobileQrSignatureHandler,
};
